/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Selectall1Inputs */

const zh_common_selectall1 = /** @type {(inputs: Common_Selectall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全选`)
};

const en_common_selectall1 = /** @type {(inputs: Common_Selectall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All`)
};

const es_common_selectall1 = /** @type {(inputs: Common_Selectall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo`)
};

/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Common_Selectall1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_selectall1 = /** @type {((inputs?: Common_Selectall1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Selectall1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_selectall1(inputs)
	if (locale === "en") return en_common_selectall1(inputs)
	return es_common_selectall1(inputs)
});
export { common_selectall1 as "common_selectAll" }